module.exports = __webpack_public_path__ + "img/arrow-top.22ab10f8.svg";